/* eslint react/no-multi-comp: 0, react/prop-types: 0 */

import React, { Component, PropTypes } from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {setPaymentsDefault, getPaymentsDefault, getUserLegals} from '../../User/redux/userAction';

import { Modal, Container, ModalHeader, ModalFooter, Button } from 'src/components/Common/reactstrap/lib';
import Radio from 'src/components/Radio/Radio';



class ModalSelectCompany extends React.Component {
  constructor(props) {
    super(props);
      props.getPaymentsDefault();
      props.getUserLegals();

  }
  renderLegals(id) {

    return this.props.userData.legals.map((legal) => {
      //console.log(id);
      return(
          <div className="mt-1" key={legal.legalId}>
            <Radio
              disabled={false}
              labelText={`От лица компании ${legal.name}`}
              name={legal.legalId}
              onChange={() => this.props.setPaymentsDefault(legal.legalId, true)}
              checked={id==legal.legalId}
            />
          </div>);

    });
  }

  render() {
    // console.log(this);
    let paymentDefault = this.props.userData.paymentDefault;
    return (
      <Modal isOpen={this.props.visible} toggle={this.props.close} className={this.props.className}>
        <ModalHeader toggle={this.props.close}>На какую компанию оформлять заказ?</ModalHeader>
        <Container>
          <Radio
            disabled={false}
            labelText="От физического лица"
            name="individual"
            onChange={() => this.props.setPaymentsDefault(0, true)}
            checked={paymentDefault == 0}
          />
          {this.renderLegals(paymentDefault)}
        </Container>
        <ModalFooter>
          <Button onClick={this.props.submit}>Выбрать</Button>
        </ModalFooter>
      </Modal>
    );
  }
}

ModalSelectCompany.propTypes = {
  isOpen:  PropTypes.bool,

  toggle:  PropTypes.func,

  size: PropTypes.string,

  backdrop: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.oneOf(['static'])
  ]),
  keyboard: PropTypes.bool,

  zIndex: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
};
export default connect(
  (state) => ({
    userData: state.userReducer
  }),
  (dispatch) => ({
    setPaymentsDefault: bindActionCreators(setPaymentsDefault, dispatch),
    getPaymentsDefault: bindActionCreators(getPaymentsDefault, dispatch),
    getUserLegals: bindActionCreators(getUserLegals, dispatch)
  })
)(ModalSelectCompany);




/** WEBPACK FOOTER **
 ** ./src/components/Cart/elements/ModalSelectCompany.jsx
 **/